import React from 'react';
import MyTypes from 'MyTypes'
import { commonFeatureActions, commonFeatureSelectors } from '../../features/commonfeature';
import { bindActionCreators, Dispatch } from 'redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { withStyles, Typography, Button } from '@material-ui/core';
import { connect } from 'react-redux';
import GeographicLocationDisplay from '../../components/geographiclocationdisplay/GeographicLocationDisplay'
import { getColumns as getGeographicLocationColumns } from '../../components/geographiclocationdisplay/columns'
import { ChangeSet } from '@devexpress/dx-react-grid';
import RefreshIcon from '@material-ui/icons/Refresh';

const mapStateToProps = (state: MyTypes.RootState) => ({
    geographicLocationsData: commonFeatureSelectors.getGeographicLocationData(state.commonFeatures)  
})

const mapDispatchToProps = (dispatch: Dispatch<MyTypes.RootAction>) => 
    bindActionCreators(
        {

            updateAppBarConfig: commonFeatureActions.updateAppBarConfig,
            getPaginatedGeographicLocation: commonFeatureActions.getPaginatedGeographicLocationRequest
        },
        dispatch
    )


const styles = {
    container: {
        width: '100%'
    }
}

type Props = {
    container: string
}

type RealProps = RouteComponentProps & Props & ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>

class GeographicLocationPage extends React.Component<RealProps> {
    state = {
        page: 0,
        perPage: 10,
        addedRows: []
    }
    
    componentDidMount() {
        this.props.updateAppBarConfig({ title: 'Geographic Location' }) 
        this.getNext()
    }

    onCurrentPageChange = (currentPage: number) => {
        console.log('onChange Current Page', currentPage)
        this.setState({
            page: currentPage
        }, ()=> {
            this.getNext()
        })
    }

    getNext = () => {
        console.log('Geographic Location get Next')
        // TODO get something
        this.props.getPaginatedGeographicLocation({
            page: this.state.page + 1,
            perPage: this.state.perPage
        })
    }

    onPageSizeChange = (pageSize: number) => {
        this.setState( { perPage: pageSize }, ()=> { this.getNext() })
    }

    onCommitEditing = (changeSet: ChangeSet) => {
        console.log('onCommitEditing: changeSet: ', changeSet)
    }

    onAddedRowsChange = (rows: any[]) => {
        console.log('onAddedRowsChange', rows)
        
        let newArray = rows
        // newArray.push({id: 1, latitude: '1', longitude: '12'})
        this.setState({
            addedRows: newArray
        })
    }

    render() {
        const { container, history, geographicLocationsData } = this.props;
        const { addedRows, page, perPage } = this.state
        console.log('addedRows from state', addedRows)
        
        return (
            <div className={container}>
                <Button
                    style={{margin: '1em'}}
                    onClick={this.getNext}
                    variant="contained"
                    color="primary"
                ><RefreshIcon /> Refresh </Button>
                
                <GeographicLocationDisplay
                    showAdd={true}
                    onAddedRowsChange={this.onAddedRowsChange}
                    addedRows={this.state.addedRows}
                    onPageSizeChange={this.onPageSizeChange}
                    onCurrentPageChange={this.onCurrentPageChange}
                    columns={getGeographicLocationColumns(history, addedRows.length > 0)}
                    editColumnExtensions={[{columnName: 'name', editingEnabled: false}, {columnName: 'description', editingEnabled: false}]}
                    data={geographicLocationsData.cached == null ? null : geographicLocationsData.cached!!.items}
                    totalCount={geographicLocationsData.cached == null ? undefined : geographicLocationsData.cached.total}
                    showEdit={false}
                    page={page}
                    perPage={perPage}
                    />
            </div>
        )
    }
}


export default withRouter(withStyles(styles)(connect(
    mapStateToProps,
    mapDispatchToProps
)(GeographicLocationPage)))